module.exports = __webpack_public_path__ + "img/sede.326f1e70.png";